var render, staticRenderFns
import script from "./BarChar.vue?vue&type=script&lang=js&"
export * from "./BarChar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f5f64e",
  null
  
)

export default component.exports